var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0v5c0 3-2.2 5.4-5 5.9V14h4v2H3v-2h4v-3.1C4.2 10.4 2 8 2 5V0h2v5a4 4 0 108 0V0h2z",
    fill: "currentColor"
  })));
}

var MemoSvgGlass = /*#__PURE__*/React.memo(SvgGlass);
export default MemoSvgGlass;